module.exports = __webpack_public_path__ + "img/img85.8729c349.png";